import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {commaFormat} = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, ledgerData) => {
        var doc = {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            pageMargins: [40, 100, 30, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(ledgerData),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },

            info: {
                title: 'Customer Statement'
            }
        }

        pushIntoTable(doc, ledgerData)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (ledgerData) => {
        return [
            {
                text: 'Customer Statement',
                style: 'header',
                margin: [0, 0, 5, 5],
                bold: true,
                color: 'black',
                fontSize: 20,
            },

            {
                margin: [0, 20, 0, 0],
                alignment: 'justify',
                columns: [
                    {
                        width: '50%',
                        stack: [
                            {
                                text: `${ledgerData.contact_profile.name ? 'Party Name: ' + ledgerData.contact_profile.name + '(' +  ledgerData.contact_profile.serial_no + ')' : ''}`
                            },
                            {
                                text: `${ledgerData.contact_profile.phone ? 'Mobile: ' + ledgerData.contact_profile.phone : ''}`
                            },
                            {
                                text: `${ledgerData.contact_profile.address ? 'Address: ' + ledgerData.contact_profile.address : ''}`
                            },
                            {
                                text: `${ledgerData.report_period ? 'Report Period: ' + ledgerData.report_period : ''}`
                            },
                        ]
                    },

                    {
                        alignment: 'right',
                        stack: [
                            {
                                text: `Opening Balance: ${commaFormat(ledgerData.opening_balance)}`
                            },

                            {
                                text: `Total Sales: ${commaFormat(ledgerData.total_sales)}`
                            },

                            {
                                text: `Total Collection: ${commaFormat(ledgerData.total_collection)}`
                            },

                            {
                                text: `Total Adjustment: ${commaFormat(ledgerData.total_adjustment)}`
                            },

                            {
                                text: `Closing Balance: ${commaFormat(ledgerData.closing_balance)}`
                            }
                        ]
                    },
                ]
            },

            getAgingSection(ledgerData),

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: [],
                    widths: ['8%', '8%', '8%', '8%', '9%', '9%', '8%', '9%', '9%', '9%', '8%', '7%']
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const getAgingSection = (ledgerData) => {
        const agingPeriods = ledgerData.aging_periods || []
        const agingData    = ledgerData.aging_data    || {}

        const allColumns = [
            {
                stack: [{
                    table: {
                        widths: ['100%'],
                        body: [
                            [{ text: 'Overdue', bold: true, fontSize: 15, color: 'red', margin: [4, 3, 4, 3] }],
                            [{
                                text: commaFormat(ledgerData.closing_balance),
                                bold: true,
                                fontSize: 12,
                                color: 'red',
                                alignment: 'left',
                                margin: [4, 3, 4, 3]
                            }]
                        ]
                    },
                    layout: {
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 0.5 : 0;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 0.5 : 0;
                        }
                    }
                }]
            },

            ...agingPeriods.map((period) => {
                return {
                    stack: [{
                        table: {
                            widths: ['100%'],
                            body: [
                                [{ text: period.name, bold: true, fontSize: 15, color: 'black', margin: [4, 3, 4, 3] }],
                                [{
                                    text: commaFormat(agingData[period.label] || 0),
                                    bold: true,
                                    fontSize: 12,
                                    color: 'black',
                                    alignment: 'left',
                                    margin: [4, 3, 4, 3]
                                }]
                            ]
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0.5 : 0;
                            },
                            vLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? 0.5 : 0;
                            }
                        }
                    }]
                }
            })
        ]

        return {
            margin: [0, 10, 0, 0],
            columns: allColumns,
            columnGap: 5
        }
    }

    const pushIntoTable = (doc, ledgerData) => {
        const tableItems = ledgerData.ledgers;
        const tableHeader = getTableHeader();
        doc.content[3].table.body.push(tableHeader);
        const openingBalanceRow = getOpeningBalance(ledgerData)
        doc.content[3].table.body.push(openingBalanceRow);
        tableItems.forEach(item => {
            const rowData = getRowData(item);
            return doc.content[3].table.body.push(rowData);
        });
        const getLastRow = getTotal(ledgerData)
        doc.content[3].table.body.push(getLastRow);
    }

    const getOpeningBalance = (ledgerData) => {
        const lastRow = [
            { text: 'Opening Balance', alignment: 'right', colSpan: 6, bold: true },
            '', '', '', '', '',
            { text: commaFormat(ledgerData.opening_balance), alignment: 'right', bold: true },
            { text: '' },
            { text: '' },
            { text: '' },
            { text: '' },
            { text: '' },
        ]
        return lastRow
    }

    const getTotal = (ledgerData) => {
        const lastRow = [
            { text: 'Closing Balance', alignment: 'right', colSpan: 6, bold: true },
            '', '', '', '', '',
            { text: commaFormat(ledgerData.closing_balance), alignment: 'right', bold: true },
            { text: '' },
            { text: '' },
            { text: '' },
            { text: '' },
            { text: '' },
        ]
        return lastRow
    }

    const getTableHeader = () => {
        const tableHeader = [
            {text: 'Date'},
            {text: 'Transaction Type'},
            {text: 'Transaction No'},
            {text: 'Voucher No'},
            {text: 'Debit', alignment: 'right'},
            {text: 'Credit', alignment: 'right'},
            {text: 'Balance', alignment: 'right'},
            {text: 'Invoice Amount', alignment: 'right'},
            {text: 'Paid Amount', alignment: 'right'},
            {text: 'Adjustment Amount', alignment: 'right'},
            {text: 'Due Amount', alignment: 'right'},
            {text: 'Status'},
        ]

        return tableHeader
    }

    const getRowData = (item) => {
        const tableRow = [
            {text: item.formatted_date},
            {text: item.txn_type},
            {text: item.bill_number},
            {text: item.voucher_no},
            {text: commaFormat(item.debit), alignment: 'right'},
            {text: commaFormat(item.credit), alignment: 'right'},
            {text: commaFormat(item.balance), alignment: 'right'},
            {text: item.txn_type === 'invoice_journal' ? commaFormat(item.subtotal_amount) : '', alignment: 'right'},
            {text: item.txn_type === 'invoice_journal' ? commaFormat(item.paid_amount) : '', alignment: 'right'},
            {text: item.txn_type === 'invoice_journal' ? commaFormat(item.adjusted_amount - item.discount) : '', alignment: 'right'},
            {text: item.txn_type === 'invoice_journal' ? commaFormat(item.due_amount) : '', alignment: 'right'},
            {text: item.txn_type === 'invoice_journal' ? item.payment_status.toUpperCase() : ''},
        ]

        return tableRow
    }

    return {
        exportToPDF
    }

}

export default pdfPrinter;